module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_8019.ee112021.png";